import { memo, ReactElement, useCallback } from 'react';
import { FilterDTO } from '../../api';
import { FilterSpec } from './common';
import { FilterChipImplementations } from './Chips';
import React from 'react';

interface ActiveFiltersChipsProps {
  filter: FilterDTO;
  filterSpec: FilterSpec[];
  onFilterChange: (filter: FilterDTO) => void;
}

export const ActiveFilterChips = memo(function ({
  filter,
  filterSpec,
  onFilterChange,
}: ActiveFiltersChipsProps): ReactElement {
  const handleValueChange = useCallback(
    function <T extends FilterDTO[keyof FilterDTO]>(key: keyof FilterDTO, value: T): void {
      if (value === undefined) {
        // remove filter
        onFilterChange(Object.fromEntries(Object.entries(filter).filter(([k]) => k !== key)));
      } else if (value !== filter[key] || undefined) {
        onFilterChange({ ...filter, [key]: value });
      }
    },
    [filter, onFilterChange]
  );

  return (
    <>
      {filterSpec
        .filter(({ filterKey }) => !!filter[filterKey])
        .map(({ type, filterProps = {}, filterKey, displayName }, idx) => {
          const FilterChip = FilterChipImplementations[type];
          return (
            <React.Fragment key={filterKey}>
              <FilterChip
                {...filterProps}
                key={idx}
                displayName={displayName ?? `delivery.${filterKey}`}
                filterKey={filterKey}
                value={filter[filterKey]}
                onValueChange={(v) => handleValueChange(filterKey, v)}
              />
            </React.Fragment>
          );
        })}
    </>
  );
});
